// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_3g7yj","app-store":"_2v4eg","social-icons":"_1Ppv-","follow-us":"_1CC8c","hyphen-symbol":"_21TTC"};